import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { officeAuthApi } from '../../services/tradeLicenseApi';
import './OfficeLogin.css';

const OfficeLogin = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await officeAuthApi.ensureCsrf();
      const response = await officeAuthApi.login(username, password);
      onLoginSuccess(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check credentials and backend connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="office-login-page">
      <div className="office-login-card">
        <h1>Trade License Office Portal</h1>
        <p>Sign in with your office credentials</p>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <p className="office-login-alt">
          <Link to="/official-login">Other login options</Link>
        </p>
      </div>
    </div>
  );
};

export default OfficeLogin;
